export default __webpack_public_path__ + "static/media/photogallery.8016b795.svg";